const Home = () => import('@/views/Home/home')

/**
 * hidden: true                   是否显示在侧栏上
 * meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
 **/

export const OperationsManagementRouteMap = {
  OperationsManagement: 'operations-management',
  SystemSettings: 'system-settings',
  EventSettings: 'event-settings',
  PlatformStatistics: 'platform-statistics',
  CustomerFeedBack: 'custom-feedback',
}

const OperationsManagement = [
  {
    path: '/deploy',
    name: OperationsManagementRouteMap.SystemSettings,
    title: '系统通知',
    component: Home,
    meta: {
      title: '系统通知',
      active: ['verifyBills'],
      permission: 'operating:system',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/deploy',
    name: OperationsManagementRouteMap.EventSettings,
    title: '营销活动',
    component: Home,
    meta: {
      title: '营销活动',
      active: ['verifyBills'],
      permission: 'operating:activity',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/deploy',
    name: OperationsManagementRouteMap.PlatformStatistics,
    title: '平台统计',
    component: Home,
    meta: {
      title: '活动设置',
      active: ['verifyBills'],
      permission: 'operating:platform:stat',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/deploy',
    name: OperationsManagementRouteMap.CustomerFeedBack,
    title: '用户反馈',
    component: Home,
    meta: {
      title: '用户反馈',
      active: ['verifyBills'],
      permission: 'operating:user:feedback',
      showSubiems: false,
    },
    children: [],
  },
]

export default OperationsManagement
